<template>
    <main class="app-body">
        <!-- Main content -->
        <participant-grid
            :active-filters="activeFilters"
            @filtersCreated="setFilters"
        ></participant-grid>

        <!-- Filters -->
        <app-sidebar
            :filter-set="filterSet"
            v-if="filterSet"
            @filterChange="onFilterChange"
        ></app-sidebar>
    </main>
</template>

<script>
import AppSidebar from "./AppSidebar";
import ParticipantGrid from "./grid/ParticipantGrid";

export default {
    name: "AppBody",
    components: {
        AppSidebar,
        ParticipantGrid
    },
    data() {
        return {
            activeFilters: null,
            filterSet: null
        };
    },
    methods: {
        onFilterChange(filters) {
            this.activeFilters = filters;
        },
        setFilters(filterSet) {
            this.filterSet = filterSet;
        }
    }
};
</script>

<style lang="scss">
@media screen {
    .app-body {
        z-index: 0;

        @include media-breakpoint-up(lg) {
            position: relative;
            display: flex;
            flex: 1;
            overflow: hidden;
        }
    }
}

.app-body > .hc-alert {
    flex: 1;
    align-self: flex-start;
}
</style>
